<div class="wrap-pagination">
    <div *ngIf="totalRecords > 10" class="d-flex justify-content-between align-items-center mb-3">
        <div class="wrap-rows">
            Afficher
            <p-dropdown
                [(ngModel)]="pageSize"
                (onChange)="onChangeRow($event)"
                class="item-page"
                [options]="listRows"
                optionLabel=""
            >
            </p-dropdown
            >éléments
        </div>
        <p-paginator
           *ngIf="totalRecords >= 10"
            (onPageChange)="onPageChange($event)"
            [rows]="pageSize"
            [totalRecords]="totalRecords"
            [showFirstLastIcon]="false"
            [showCurrentPageReport]="false"
        ></p-paginator>
    </div>
</div>
